import React from 'react';
import { ReactComponent as StarIcon } from '@/assets/icons/hotel/star.svg';
import { ReactComponent as StarHalfIcon } from '@/assets/icons/hotel/start-half.svg';
import { range } from 'lodash';

type Props = {
  star: number;
};

export default function HotelStar({ star }: Props) {
  const rangeStar = React.useMemo(() => {
    return range(0, Math.floor(star));
  }, [star]);
  return (
    <span className="d-inline-block">
      {rangeStar.map(r => {
        return <StarIcon key={r} className="text-14 text-yellow-1 mr-4" style={{ width: 14 }} />;
      })}
      {Math.floor(star) !== star ? <StarHalfIcon className="text-14 text-yellow-1 mr-4" style={{ width: 14 }} /> : null}
    </span>
  );
}
